export default theme => ({
  actions: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: 40,
    '& .MuiButton-root:first-child': {
      marginRight: theme.spacing(2)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },

  // Copied from DataWizard
  messageList: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  message: {
    margin: '0 0 20px 0',
    '&:last-child': {
      margin: 0
    }
  },
  success: {
    color: 'green'
  },
  failure: {
    color: 'red'
  },
  violatedConstraints: {
    listStyle: 'none',
    margin: '10px 0 0 0',
    padding: 0
  },
  constraints: {
    padding: '0 0 10px 0',
    '&:last-child': {
      padding: 0
    }
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px'
  },
  importContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 73px)', // necessary because this page has the Stepper that affects the layout.
    paddingBottom: 40
  }
});
